import getApi from '../../api'
import { Speciality } from '../../model/Professions'

export const getSpecialities = () => getApi().get<Array<Speciality>>('/specialities')
